import React from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import EmptyState from 'assets/images/cloud-and-lock.webp';

import './ShareableLinkLockScreen.styles.scss';

type ShareableLinkLockScreenProps = {
  className?: string;
  title: string;
  description?: string;
  image?: string;
};

const ShareableLinkLockScreen: React.FC<ShareableLinkLockScreenProps> = (
  props,
) => {
  const { className, children, title, description, image } = props;

  const classes = classNames('shareable-link-lock-screen', className);

  return (
    <div className={classes}>
      <h2>{title}</h2>

      <ResolveImage
        src={image || EmptyState}
        asIllustration
        alt="Nothing to see here yet."
      />

      {description && <p>{description}</p>}
      {children}
    </div>
  );
};

export default ShareableLinkLockScreen;
